import { useState , useEffect } from 'react';
import compose from 'recompose/compose';
import { withAgentPage, withLayout } from 'hocs'
import GiftsHeader from 'newComponents/GiftsHeader/GiftsHeaderNavigate';
import CardTitleEvent from 'newComponents/CardTitleEvent';
import WalletComponent from 'newComponents/Wallet/WalletComponent';
import GiftsRecived from 'newComponents/Wallet/GiftsRecived';
import EdosCuentaMonedero from 'newComponents/Wallet/EdosCuenta';
import MenuMultiButons from 'newComponents/MenuMultiButons';
import styles from './styles.module.sass'


const NewListOfGiftsReceived = () => {
    
    const [ responseTable, setResponseTable ] = useState(null)
    const [ , setTotal ] = useState(null)
    const [ , setIsEmpty ] = useState(null)
    
    const [ eventID, setEventID ] = useState(null)
    const [ eventWallet, setEventWallet ] = useState(null)
    const [ monedero, setMonedero ] = useState(null)

    useEffect(()=>{
        setMonedero(null)
    },[])
        
    useEffect(()=>{
        if(responseTable){
            setMonedero(null)
            setEventID(responseTable?.id)
            setEventWallet(responseTable?.wallet)
        }
    },[responseTable])

    const [ edosCuenta, setEdosCuenta ] = useState(false)
    const [ hashToken, setHashToken ] = useState(null)
    const [ saldoActual, setSaldoActual ] = useState('$0')

    return(
        <>
            <GiftsHeader
                setResponseTable={setResponseTable}
                setTotal={setTotal}
                setIsEmpty={setIsEmpty}
            />
             <div className={styles?.externalContainer}>
                <CardTitleEvent
                    responseTable={responseTable}
                />

                <div className={`containerPortal ${styles?.container}`}>
                    <MenuMultiButons
                        linea={11}
                    />

                    <h1 className={styles?.title}>Mi monedero SEARS</h1>
                    <div>
                        {monedero
                            ?
                                edosCuenta 
                                    ?
                                        <EdosCuentaMonedero
                                            setMonedero={setMonedero}
                                            setEdosCuenta={setEdosCuenta}
                                            hashToken={hashToken}
                                            saldo_actual={saldoActual}
                                        />
                                    :
                                        <WalletComponent
                                            monedero={monedero}
                                            eventWallet={eventWallet}
                                            setEdosCuenta={setEdosCuenta}
                                            setHashToken={setHashToken}
                                            setSaldoActual={setSaldoActual}
                                        />
                            : 
                                 <GiftsRecived
                                    eventID={eventID}
                                    responseTable={responseTable}
                                    eventWallet={eventWallet}
                                    setMonedero={setMonedero}
                                    setEdosCuenta={setEdosCuenta}
                                />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default compose(
    withLayout, 
    withAgentPage({ fetchTableInfo: true })
)(NewListOfGiftsReceived);